{
  "title": "Welcome back",
  "subtitle": "Use your work email to continue.",
  "field": {
    "email": "Work email",
    "password": "Password",
    "old_password": "Current password",
    "new_password": "New password",
    "confirm_password": "Confirm new password"
  },
  "placeholder": {
    "email": "name@aloshop.com"
  },
  "action": {
    "sign_in": "Sign in",
    "keep_signed_in": "Keep me signed in",
    "need_help": "Need help?",
    "logout": "Sign out",
    "change_password": "Change password"
  },
  "header": {
    "signed_in_as": "Signed in as"
  },
  "error": {
    "invalid": "Email or password incorrect",
    "lockout": "Too many attempts. Try again in {{minutes}} minutes.",
    "old_password_invalid": "Current password is incorrect"
  },
  "security_notice": "This is a private system. All activity is logged and reviewed.",
  "change_password": {
    "title": "Change your password",
    "subtitle": "Choose a new password. You'll be signed out everywhere else.",
    "success": "Password changed. Please sign in again."
  }
}
